const BusinessTier = {
  BASIC: "BASIC",
  PREMIUM: "PREMIUM",
} as const;

type BusinessTier = (typeof BusinessTier)[keyof typeof BusinessTier];

export default BusinessTier;
export type { BusinessTier };
